import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { chicaService, convertirChicaDTO } from './services/api';
import './App.css';
import HamburgerMenu from './components/HamburgerMenu';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [showWhatsApp, setShowWhatsApp] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const navigate = useNavigate();

  // Estados para datos de la API
  const [chicas, setChicas] = useState([]);
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Mapeo temporal de imágenes por ID
  const imagenesChicas = {
    1: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop",
    2: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=600&fit=crop",
    3: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=600&fit=crop",
    4: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=600&fit=crop",
    5: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop",
    6: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=600&fit=crop",
    7: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop",
    8: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=600&fit=crop",
    9: "https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=400&h=600&fit=crop",
    10: "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=400&h=600&fit=crop",
    11: "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?w=400&h=600&fit=crop",
    12: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop",
    13: "https://images.unsplash.com/photo-1513956589380-bad6acb9b9d4?w=400&h=600&fit=crop",
    14: "https://images.unsplash.com/photo-1515191107209-c28698631303?w=400&h=600&fit=crop",
    15: "https://images.unsplash.com/photo-1516575150278-77136aed6920?w=400&h=600&fit=crop",
  };

  // Verificar si hay usuario logueado
  useEffect(() => {
    const usuarioActual = localStorage.getItem('usuarioActual');
    if (usuarioActual) {
      setUsuario(JSON.parse(usuarioActual));
    }
  }, []);

  // Cargar chicas de la API
  useEffect(() => {
    cargarChicas();
  }, []);

  const cargarChicas = async () => {
    try {
      setLoading(true);
      setError(null);

      // Obtener todas las chicas de la API
      const chicasData = await chicaService.obtenerTodas();
      
      // Convertir DTOs
      const chicasConvertidas = chicasData.map(convertirChicaDTO);
      
      // Agregar imágenes del mapeo temporal
      const chicasConImagenes = chicasConvertidas.map(chica => ({
        ...chica,
        imagen: imagenesChicas[chica.id] || imagenesChicas[1]
      }));

      // Primeras 9 para la página principal
      setChicas(chicasConImagenes.slice(0, 9));
      
      // Top 10 para el ranking (por ahora las primeras 10)
      // TODO: Crear endpoint en backend que ordene por número de citas
      setRanking(chicasConImagenes.slice(0, 10).map((chica, idx) => ({
        posicion: idx + 1,
        nombre: chica.nombre,
        edad: chica.edad,
        distritos: chica.distritosDisponibles || [chica.distrito],
        imagen: chica.imagen
      })));

    } catch (err) {
      console.error('Error al cargar chicas:', err);
      setError('Error al cargar las chicas. Por favor recarga la página.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('usuarioActual');
    setUsuario(null);
    alert('Sesión cerrada correctamente');
  };

  // Mostrar botón de WhatsApp al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowWhatsApp(true);
      } else {
        setShowWhatsApp(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const caracteristicas = [
    { nombre: "Chica Gótica", endpoint: "gotica" },
    { nombre: "Chica Cosplayer", endpoint: "cosplayer" },
    { nombre: "Chica Otaku", endpoint: "otaku" },
    { nombre: "Chica Gamer", endpoint: "gamer" },
    { nombre: "Chica Adorable", endpoint: "adorable" },
    { nombre: "Chica Fitness", endpoint: "fitness" },
    { nombre: "Chica Cinefila", endpoint: "cinefila" },
    { nombre: "Chica Milf", endpoint: "milf" },
    { nombre: "Chica Extrovertida", endpoint: "extrovertida" },
    { nombre: "Chica Tímida", endpoint: "timida" }
  ];

  const distritosLima = [
    { 
      nombre: "Miraflores", 
      imagen: "https://parquedelareserva.com.pe/wp-content/uploads/2022/04/Parque-Kennedy-Parque-Central-de-Miraflores.jpg",
      descripcion: "El distrito más turístico y romántico"
    },
    { 
      nombre: "San Isidro", 
      imagen: "https://m.ahstatic.com/is/image/accorhotels/san-isidro-que-hacer-en-lima-2024-1:16by9?fmt=webp&op_usm=1.75,0.3,2,0&resMode=sharp2&iccEmbed=true&icc=sRGB&dpr=on,1.3&wid=1459&hei=820&qlt=80",
      descripcion: "Elegancia y sofisticación"
    },
    { 
      nombre: "Barranco", 
      imagen: "https://www.peru.travel/Contenido/Noticia/Imagen/es/1420/1.0/Principal/barranco-timeout.jpg",
      descripcion: "Arte, cultura y bohemia"
    },
    { 
      nombre: "Surco", 
      imagen: "https://blog.properati.com.pe/wp-content/uploads/2019/10/surco-distritos-seguros-4.jpg",
      descripcion: "Moderno y residencial"
    },
    { 
      nombre: "San Borja", 
      imagen: "https://larepublica.cronosmedia.glr.pe/original/2024/03/22/65fdf55b5b976640cd68b0be.jpg",
      descripcion: "Seguro y familiar"
    },
    { 
      nombre: "Magdalena", 
      imagen: "https://blog.properati.com.pe/wp-content/uploads/2021/06/Captura-de-pantalla-2021-06-18-a-las-17.30.47.png",
      descripcion: "Tradicional y acogedor"
    },
    { 
      nombre: "Lince", 
      imagen: "https://gestion.pe/resizer/v2/Z4KJWDFHFFF6BDHOCZ2ZI2BBIQ.jpg?auth=7be3923efdfee15427cb7edefa6b2ab63c946fc05dd4e9205d1e66fad5f73b9d&width=2000&height=1354&quality=75&smart=true",
      descripcion: "Céntrico y accesible"
    },
    { 
      nombre: "Jesús María", 
      imagen: "https://larepublica.cronosmedia.glr.pe/migration/images/FSPV64TLBBFI3F3S2SKXKCVG3U.jpg",
      descripcion: "Cultural y educativo"
    },
    { 
      nombre: "San Miguel", 
      imagen: "https://gestion.pe/resizer/v2/OQIACY7YQBAA3EXJOLFDJBMEWE.png?auth=c0c3c7aecf5cd236927fb067d2e3c5bc60e63accca5773f2d3ec9cd662906f83&width=1200&height=800&quality=75&smart=true",
      descripcion: "Comercio y tradición"
    },
    { 
      nombre: "Pueblo Libre", 
      imagen: "https://antiguatabernaqueirolo.com/wp-content/uploads/2018/09/un-paseo-por-pueblo-libre.jpg",
      descripcion: "Histórico y tranquilo"
    },
    { 
      nombre: "Surquillo", 
      imagen: "https://urbania.pe/blog/wp-content/uploads/2018/05/imovelwebcomunicacaoltda_quintoandarperu_image_669.jpeg",
      descripcion: "Emergente y cultural"
    }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  const preguntasFrecuentes = [
    {
      categoria: 'Sobre el Uso',
      key: 'usage',
      preguntas: [
        {
          pregunta: 'Solo quiero tener una cita por una hora',
          respuesta: 'Nuestro servicio funciona con un tiempo mínimo de 2 horas. Si decides finalizar la cita antes, igual se cobrará el tiempo mínimo establecido.'
        },
        {
          pregunta: '¿Puedo comunicarme directamente con ella por correo o mensaje?',
          respuesta: 'Sí. Para concretar una reserva, podrás comunicarte con tu novia asignada a través de los canales habilitados dentro de la plataforma, con el fin de coordinar fecha y detalles.'
        },
        {
          pregunta: '¿Puedo tener citas fuera de mi distrito o en zonas lejanas?',
          respuesta: 'Generalmente es posible. Sin embargo, la disponibilidad y el costo pueden variar según la distancia entre distritos y si se encuentran dentro de las zonas de cobertura establecidas en Lima. Te recomendamos consultar esto antes de confirmar tu reserva.'
        },
      ]
    },
    {
      categoria: 'Tarifas y Pagos',
      key: 'payment',
      preguntas: [
        {
          pregunta: '¿Cuáles son los métodos de pago?',
          respuesta: 'Aceptamos transferencia bancaria, tarjeta de crédito/débito, y pagos digitales como Yape o Plin.'
        },
        {
          pregunta: '¿Cuándo debo realizar el pago?',
          respuesta: 'El pago debe realizarse dentro del plazo indicado al confirmar la reserva. Por lo general, el límite es hasta 48 horas después de la confirmación.'
        },
      ]
    },
    {
      categoria: 'Reservas, Cambios y Recomendaciones',
      key: 'reservation',
      preguntas: [
        {
          pregunta: '¿Cómo realizo una reserva?',
          respuesta: 'Selecciona a la novia de tu preferencia desde su perfil y envía una solicitud de reserva. Luego sigue el flujo indicado por la plataforma.'
        },
        {
          pregunta: 'Quiero cancelar mi reserva',
          respuesta: 'La cancelación será gratuita si se realiza hasta con seis días de anticipación, se aplicará un cargo del 50% si se solicita entre cinco días y un día antes de la fecha reservada, y se cobrará 100% del monto total si la cancelación se realiza el mismo día de la cita o por inasistencia.'
        },
      ]
    }
  ];

  if (loading) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '24px',
          color: '#ec4899'
        }}>
          Cargando...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: '20px'
        }}>
          <div style={{ fontSize: '24px', color: '#ef4444' }}>{error}</div>
          <button 
            onClick={cargarChicas}
            style={{
              padding: '12px 24px',
              background: '#ec4899',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <HamburgerMenu />
      
      {/* Top Banner */}
      <div className="top-banner">
        <a href="#recruit" className="banner-link">
          <span className="banner-icon">👧</span>
          ¡Reclutando nuevas novias!
        </a>
      </div>

      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <h1 className="main-logo">
                <span className="logo-text">Novia de Alquiler</span>
                <span className="logo-brand">"Kano Lima"</span>
                <span className="logo-subtitle">Sitio General</span>
              </h1>
              <p className="locations-text">
                SAN MIGUEL / MIRAFLORES / BARRANCO / LINCE / JESÚS MARÍA / SAN ISIDRO / SURCO / MAGDALENA / SAN BORJA / SURQUILLO / PUEBLO LIBRE
              </p>
            </div>
            
            <div className="auth-buttons">
              {usuario ? (
                <>
                  <span className="user-welcome">¡Hola, {usuario.nombreCompleto}!</span>
                  <button className="btn-mis-citas" onClick={() => navigate('/mis-citas')}>
                     📋 Mis Citas
                  </button>
                  <button className="btn-logout" onClick={handleLogout}>Cerrar Sesión</button>
                </>
              ) : (
                <>
                  <button className="btn-login" onClick={() => navigate('/login')}>Iniciar Sesión</button>
                  <button className="btn-register" onClick={() => navigate('/registro')}>Registrarse</button>
                </>
              )}
            </div>
          </div>

          <nav className="main-nav">
            <button className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </button>

            <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              <li><a href="#top" onClick={(e) => { e.preventDefault(); scrollToSection('top'); }}>Página Principal</a></li>
              <li><a href="#girls" onClick={(e) => { e.preventDefault(); scrollToSection('girls'); }}>Presentación de Novias</a></li>
              <li><a href="#ranking" onClick={(e) => { e.preventDefault(); scrollToSection('ranking'); }}>Ranking General</a></li>
              <li><a href="#distritos" onClick={(e) => { e.preventDefault(); scrollToSection('distritos'); }}>Chicas por Distrito</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>¿Qué es Novia de Alquiler?</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }}>Preguntas Frecuentes</a></li>
              <li><a href="#categories" onClick={(e) => { e.preventDefault(); scrollToSection('categories'); }}>Presentaciones por Tipo</a></li>
              <li><a href="#review" onClick={(e) => { e.preventDefault(); scrollToSection('review'); }}>Reseñas</a></li>
              <li><a href="#follow" onClick={(e) => { e.preventDefault(); scrollToSection('follow'); }}>Síguenos</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section id="top" className="hero-section">
        <div className="hero-background"></div>
      </section>

      {/* Districts Slider */}
      <div className="districts-slider">
        <div className="districts-track">
          <span>MIRAFLORES / SAN ISIDRO / BARRANCO / SURCO / LINCE / SAN BORJA / MAGDALENA / JESÚS MARÍA / SAN MIGUEL / PUEBLO LIBRE / SURQUILLO / </span>
          <span>MIRAFLORES / SAN ISIDRO / BARRANCO / SURCO / LINCE / SAN BORJA / MAGDALENA / JESÚS MARÍA / SAN MIGUEL / PUEBLO LIBRE / SURQUILLO / </span>
        </div>
      </div>

      {/* Girls Section */}
      <section id="girls" className="girls-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Chicas</span>
            <h2 className="section-title">Presentación de Novias Kano Lima</h2>
            <p className="section-description">
              Presentamos a las novias que trabajan<br />
              en "KANO LIMA", el servicio de novia de alquiler<br />
              ¡Encuentra a tu novia favorita!
            </p>
          </div>

          <div className="girls-grid">
            {chicas.map((chica) => (
              <div 
                key={chica.id} 
                className="girl-card"
                onClick={() => navigate(`/chica/${chica.id}`)}
                style={{cursor: 'pointer'}}
              >
                <div className="girl-image-wrapper">
                  <img src={chica.imagen} alt={chica.nombre} className="girl-image" />
                  {chica.tags && chica.tags.length > 0 && (
                    <div className="girl-tags">
                      {chica.tags.map((tag, idx) => (
                        <span key={idx} className={`girl-tag ${tag.includes('Ranking') ? 'ranking' : ''}`}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="girl-info">
                  {/* Mostrar distritos disponibles */}
                  {chica.distritosDisponibles && chica.distritosDisponibles.length > 0 && (
                    <div className="girl-area">
                      {chica.distritosDisponibles.slice(0, 2).map((distrito, idx) => (
                        <span key={idx}>【{distrito}】</span>
                      ))}
                    </div>
                  )}
                  <h3 className="girl-name">{chica.nombre}</h3>
                  <div className="girl-details">
                    <span className="girl-age">{chica.edad} años</span>
                    {chica.tarifaHora && (
                      <span className="girl-tarifa"> • S/{chica.tarifaHora}/hora</span>
                    )}
                  </div>
                  {/* Mostrar descripción */}
                  {chica.descripcion && (
                    <p style={{
                      fontSize: '13px',
                      color: '#666',
                      marginTop: '8px',
                      lineHeight: '1.4',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical'
                    }}>
                      {chica.descripcion}
                    </p>
                  )}
                  {/* Badge de tipo */}
                  {chica.tipos && chica.tipos.length > 0 && (
                    <div style={{marginTop: '8px'}}>
                      <span style={{
                        background: '#ffc0cb',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        color: '#333',
                        fontWeight: '500'
                      }}>
                        Otaku
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div id="categories" className="area-links">
            <h3 className="area-links-title">Haga clic aquí para ver las presentaciones de novias por tipo.</h3>
            <div className="area-buttons">
              {caracteristicas.map((caracteristica, idx) => (
                <button 
                  key={idx} 
                  onClick={() => navigate(`/catalogo/${caracteristica.endpoint}`)}
                  className="area-btn"
                >
                  {caracteristica.nombre}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Ranking Section */}
      <section id="ranking" className="ranking-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Ranking</span>
            <h2 className="section-title">Ranking General de Novias</h2>
            <p className="section-description">
              ¡Las novias más populares de este mes!<br />
              ¡Revisa el ranking del próximo mes también!
            </p>
          </div>

          <div className="ranking-subtitle">
            Ranking de Novias Más Populares<br />
            ¡Revisa a tu novia favorita!
          </div>

          <div className="ranking-grid ranking-10">
            {/* Primera fila: top 4, top 2, top 1, top 3, top 5 */}
            {([4,2,1,3,5]).map(pos => {
              const girl = ranking.find(g => g.posicion === pos);
              if (!girl) return null;
              
              let cardClass = '';
              if (girl.posicion === 1) cardClass = ' ranking-first';
              else if (girl.posicion === 2 || girl.posicion === 3) cardClass = ' ranking-side';
              
              let numberClass = '';
              if (girl.posicion === 1) numberClass = ' gold-number';
              else if (girl.posicion === 2) numberClass = ' silver-number';
              else if (girl.posicion === 3) numberClass = ' bronze-number';
              
              return (
                <div key={girl.posicion} className={`ranking-card${cardClass}`}>
                  <div className={`ranking-number${numberClass}`}>{girl.posicion}</div>
                  <div className="ranking-image-wrapper">
                    <img 
                      src={girl.imagen}
                      alt={girl.nombre}
                      className="ranking-image"
                    />
                  </div>
                  <div className="ranking-info">
                    <div className="ranking-name">{girl.nombre}</div>
                    <div className="ranking-details">
                      ({girl.edad})<br />
                      {girl.distritos && girl.distritos.length > 0 && (
                        <>
                          [{girl.distritos.slice(0, 2).join(', ')}]
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            
            {/* Segunda fila: top 6-10 */}
            {([6,7,8,9,10]).map(pos => {
              const girl = ranking.find(g => g.posicion === pos);
              if (!girl) return null;
              
              return (
                <div key={girl.posicion} className="ranking-card">
                  <div className="ranking-number">{girl.posicion}</div>
                  <div className="ranking-image-wrapper">
                    <img 
                      src={girl.imagen}
                      alt={girl.nombre}
                      className="ranking-image"
                    />
                  </div>
                  <div className="ranking-info">
                    <div className="ranking-name">{girl.nombre}</div>
                    <div className="ranking-details">
                      ({girl.edad})<br />
                      {girl.distritos && girl.distritos.length > 0 && (
                        <>
                          [{girl.distritos.slice(0, 2).join(', ')}]
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Distritos Section */}
      <section id="distritos" className="distritos-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Ubicaciones</span>
            <h2 className="section-title">Chicas por Distrito</h2>
            <p className="section-description">
              Encuentra a tu novia ideal según el distrito de Lima<br />
              Haz clic en un distrito para ver las chicas disponibles en esa zona
            </p>
          </div>

          <div className="distritos-grid">
            {distritosLima.map((distrito, idx) => (
              <div 
                key={idx} 
                className="distrito-card"
                onClick={() => navigate(`/catalogo?distrito=${distrito.nombre}`)}
              >
                <div className="distrito-image-wrapper">
                  <img src={distrito.imagen} alt={distrito.nombre} className="distrito-image" />
                  <div className="distrito-overlay">
                    <h3 className="distrito-nombre">{distrito.nombre}</h3>
                    <p className="distrito-descripcion">{distrito.descripcion}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What is Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">¿Qué es?</span>
            <h2 className="section-title">Novia de alquiler de KANO LIMA</h2>
            <p className="section-description">
              Ofrecemos planes adaptados a tu estilo de vida y necesidades, y contamos<br />
              con un sistema de soporte para que incluso quienes lo usan por primera vez puedan usar el servicio con tranquilidad.<br />
              ¿Por qué no crear tus propios recuerdos especiales con "Kano Lima"?
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-number">01</div>
              <div className="feature-image">
                <div className="feature-icon"></div>
                <img src="https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&h=300&fit=crop" alt="Compañero de vida" />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">Compañero de vida</h3>
                <h4 className="feature-subtitle">Siéntete cómodo incluso si es la primera vez que utilizas el servicio</h4>
                <p className="feature-text">
                  Disfruta de un momento especial con un plan adaptado a tus aficiones y estilo de vida. Ofrecemos experiencias a tu medida, 
                  como ver películas, visitar cafeterías o disfrutar del aire libre. Te prometemos un apoyo atento y un servicio cordial para que 
                  puedas usar nuestros servicios con tranquilidad. Ofrecemos una experiencia especial y extraordinaria para aniversarios, 
                  cumpleaños o simplemente para renovar tu rutina diaria.
                </p>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-number">02</div>
              <div className="feature-image">
                <div className="feature-icon"></div>
                <img src="https://images.unsplash.com/photo-1511988617509-a57c8a288659?w=400&h=300&fit=crop" alt="Momento especial" />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">momento especial</h3>
                <h4 className="feature-subtitle">Como alguien con quien pasar momentos especiales</h4>
                <p className="feature-text">
                  "Kano Lima" te ayuda a planificar tu cita ideal, incluyendo lugares fotogénicos para redes sociales y cafeterías populares. 
                  ¿Por qué no convertir tu viaje en un recuerdo inolvidable que querrás compartir? Disfruta de momentos inolvidables con tu 
                  novia visitando tu destino o disfrutando de eventos de temporada. Te ayudamos a pasarlo bien y te ofrecemos momentos especiales.
                </p>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-number">03</div>
              <div className="feature-image">
                <div className="feature-icon"></div>
                <img src="https://uvn-brightspot.s3.amazonaws.com/assets/vixes/btg/gamer.batanga.com/files/5-razones-para-tener-una-novia-gamer-Pareja-gamer-0.jpg" alt="Comunicación" />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">Comunicación</h3>
                <h4 className="feature-subtitle">Disfruta de las citas online</h4>
                <p className="feature-text">
                  Incluso si te sientes ansioso o nervioso por conocer a una mujer en persona, ofrecemos citas en línea que puedes disfrutar desde 
                  la comodidad de tu hogar. Es fácil de usar para quienes no quieren salir o viven lejos. Es perfecto para quienes desean 
                  disfrutar de su tiempo libre en medio de su ajetreada vida diaria. No se requiere preparación y puedes dedicar un tiempo 
                  especial a tu medida, como hablar de tus aficiones o de tus preocupaciones. Te ayudamos a comunicarte con naturalidad en 
                  un ambiente relajado.
                </p>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-number">04</div>
              <div className="feature-image">
                <div className="feature-icon"></div>
                <img src="https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&h=300&fit=crop" alt="Consejos de moda" />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">Consejos de moda</h3>
                <h4 className="feature-subtitle">Consejos de moda para lucir mejor</h4>
                <p className="feature-text">
                  Si te preocupa no saber qué ropa te favorece o quieres saber qué moda es la tendencia femenina, te acompañaremos en tus 
                  compras y te asesoraremos. Te ayudaremos a descubrir una nueva versión de ti, sugiriendo estilos que realcen tus mejores 
                  rasgos y eligiendo la ropa juntos. Te apoyaremos para que tu día a día sea más divertido y positivo.
                </p>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-number">05</div>
              <div className="feature-image">
                <div className="feature-icon"></div>
                <img src="https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=400&h=300&fit=crop" alt="Primera impresión" />
              </div>
              <div className="feature-content">
                <h3 className="feature-title">Primera impresión</h3>
                <h4 className="feature-subtitle">Disfruta de una conversación relajada</h4>
                <p className="feature-text">
                  Incluso si no se te da bien conversar, puedes disfrutar de conversaciones naturales sobre una amplia gama de temas, 
                  desde aficiones hasta consejos para la vida, como si estuvieras hablando con un viejo amigo. Encuentra temas en común para 
                  divertirte y descubrir nuevas perspectivas. Disfruta de tu tiempo libre juntos. Puedes hablar a tu propio ritmo, ya sea en línea o 
                  desde cualquier lugar. Nuestras chicas experimentadas te ayudarán a que la conversación fluya sin problemas.
                </p>
              </div>
            </div>
          </div>

          <div className="cta-banner">
            <h3 className="cta-title">Rentemos una novia!</h3>
            <p className="cta-text">
              Como un compañero que camina junto a ti, cerca de tu corazón.<br />
              Nuestro objetivo es brindar a cada huésped una experiencia especial y placentera. Mediante<br />
              servicios adaptados a las necesidades de cada persona, haremos todo lo posible para ayudarle a<br />
              hacer su vida diaria más plena y placentera.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="faq-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Q&A</span>
            <h2 className="section-title">Preguntas Frecuentes</h2>
            <p className="section-description">
              Para quienes están considerando usar el servicio. Hemos recopilado las preguntas más frecuentes.
            </p>
          </div>

          <div className="faq-categories">
            <button className={`faq-tab ${activeTab === 'all' ? 'active' : ''}`} onClick={() => setActiveTab('all')}>
              Todas
            </button>
            <button className={`faq-tab ${activeTab === 'usage' ? 'active' : ''}`} onClick={() => setActiveTab('usage')}>
              Sobre el Uso
            </button>
            <button className={`faq-tab ${activeTab === 'payment' ? 'active' : ''}`} onClick={() => setActiveTab('payment')}>
              Tarifas y Pago
            </button>
            <button className={`faq-tab ${activeTab === 'reservation' ? 'active' : ''}`} onClick={() => setActiveTab('reservation')}>
              Reservas, Cambios y Recomendaciones
            </button>
          </div>

          <div className="faq-list">
            {preguntasFrecuentes.map((categoria) => {
              const shouldShow = activeTab === 'all' || categoria.key === activeTab;
              if (!shouldShow) return null;
              
              return (
                <div key={categoria.categoria} className="faq-category">
                  <div className="faq-category-header">
                    <h3 className="faq-category-title">{categoria.categoria}</h3>
                  </div>
                  {categoria.preguntas.map((pregunta, idx) => (
                    <details key={idx} className="faq-item">
                      <summary className="faq-question">{pregunta.pregunta}</summary>
                      <p className="faq-answer">
                        {pregunta.respuesta}
                      </p>
                    </details>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Review Section */}
      <section id="review" className="review-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Reseñas</span>
            <h2 className="section-title">Reseñas para las Novias</h2>
            <p className="section-description">
              Opiniones de los usuarios<br />
              que utilizan regularmente Kano Lima<br />
              ¡Las citas con las novias serán un tiempo maravilloso y memorable!
            </p>
          </div>

          <div className="reviews-list">
            <div className="review-card">
              <div className="review-header">
                <h3 className="review-name">Reseña para Kano Lima [【Abigail】]</h3>
              </div>
              <p className="review-text">
                Creo que después de nuestra tercera cita, nos hemos vuelto muy buenos amigos.
                ¡Su tema de conversacion es divertido sin importar qué le preguntes! Fue una novia con la que me divertí mucho estar y con la que quisiera tener otra cita.
              </p>
              <p className="review-author">[Fer]</p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <h3 className="review-name">Reseña para Kano Lima [【Izumi】]</h3>
              </div>
              <p className="review-text">
                Cuando estoy con Izumi, el tiempo pasa tan rápido,
                tengo sentimientos de felicidad y tristeza al darme cuenta de que ya es hora de despedirse.
                Pensé que sería difícil hacer una reserva ya que quedó en 3° lugar en las elecciones generales de Kano Lima,
                pero parece que todavía puedo reservar como siempre, así que me gustaría ir a otro lugar en otra cita.
              </p>
              <p className="review-author">[Siby]</p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <h3 className="review-name">Reseña para Kano Lima [【Rosi】]</h3>
              </div>
              <p className="review-text">
                Como es una novia con mucha experiencia, hace buenas sugerencias incluso si estás indeciso sobre dónde ir o qué tienda elegir,
                y disfruta de cualquier tienda o destino. ¿No es el lugar, sino con quién y cómo pasas el tiempo allí?
                Como valora esto, te dará un tiempo agradable mientras estés con ella.
              </p>
              <p className="review-author">[Henry]</p>
            </div>
          </div>
        </div>
      </section>

      {/* Recruitment Section */}
      <section id="recruit" className="recruitment-section">
        <div className="container">
          <div className="recruitment-content">
            <div className="recruitment-text">
              <h2 className="recruitment-title">Recluta</h2>
              <h3 className="recruitment-subtitle">¡Buscando una nueva novia de alquiler!</h3>
              <p className="recruitment-description">
                Kano Lima es un establecimiento popular con una de las mayores tasas de atracción de clientes del país.<br />
                Puedes ganar mucho dinero con una cita rápida en tu tiempo libre. Buscamos nuevas novias en cada zona.
              </p>
            </div>
            <div 
              className="recruitment-banner"
              onClick={() => window.open('https://wa.me/51951329353?text=Hola,%20estoy%20interesada%20en%20trabajar%20como%20novia%20de%20alquiler%20en%20Kano%20Lima', '_blank')}
            >
              <div className="recruitment-banner-content">
                <div className="recruitment-icon">☕</div>
                <div className="recruitment-spanish">Aprovecha tu tiempo libre con citas rápidas.</div>
                <div className="recruitment-main-text">¡Nueva novia de alquiler reclutando!</div>
                <button className="recruitment-button">contactanos</button>
                <div className="recruitment-brand">kano lima</div>
              </div>
              <div className="recruitment-image">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=400&fit=crop" alt="Recruitment" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Follow Us Section */}
      <section id="follow" className="follow-section">
        <div className="container">
          <div className="follow-header">
            <h2 className="follow-title">Síguenos</h2>
            <p className="follow-description">
              Con un elenco diverso y cuidadosamente seleccionado, encontrarás a tu acompañante ideal.<br />
              Elige la fecha y hora que mejor se adapten a ti.<br />
              Accede a información detallada del elenco y consulta la disponibilidad de horarios en tiempo real.
            </p>
          </div>

          <div className="social-links">
            <a href="https://x.com/KanoLima42215" target="_blank" rel="noopener noreferrer" className="social-link x">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.514l-5.106-6.666-5.829 6.666H2.422l7.732-8.835L2.75 2.25h6.696l4.809 6.357 5.287-6.357z" />
              </svg>
              <span>Propietario Oficial X</span>
            </a>
            <a href="https://www.tiktok.com/@kanolimaoficial" target="_blank" rel="noopener noreferrer" className="social-link tiktok">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.68v13.67a2.89 2.89 0 1 1-5.08-2.91 2.88 2.88 0 0 1 2.31 1.46V9.75A5.77 5.77 0 1 0 19.59 15.4" />
              </svg>
              <span>TikTok oficial</span>
            </a>
            <a href="https://youtube.com/@kanolima?si=-tXA_o2MJH_-Tpxs" target="_blank" rel="noopener noreferrer" className="social-link youtube">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
              <span>YouTube oficial</span>
            </a>
            <a href="https://www.instagram.com/kanolimaoficial/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
              </svg>
              <span>Instagram oficial</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo-section">
              <h2 className="footer-logo">
                ¡Disponible en todo Lima! Novia de Alquiler<br />
                Kano Lima
              </h2>
              <p className="footer-copyright">
                Queda prohibida la reproducción o uso de todo o parte del contenido protegido por derechos de autor,<br />
                como textos, videos y fotos en este sitio web sin el consentimiento de nuestra tienda.<br />
                Horario de atención: Días laborables 11:00〜20:00<br />
                © 2025–2026 Novia de Alquiler Kano Lima
              </p>
            </div>

            <div className="footer-links">
              <div className="footer-col">
                
              </div>

              <div className="footer-col">
                <h4>&nbsp;</h4>
                <ul>

                </ul>
              </div>
            </div>
          </div>

          <div className="back-to-top">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              Volver arriba ↑
            </button>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/51951329353?text=Hola,%20me%20gustaría%20obtener%20más%20información%20sobre%20Kano%20Lima"
        target="_blank"
        rel="noopener noreferrer"
        className={`whatsapp-float ${showWhatsApp ? 'show' : ''}`}
        aria-label="Contactar por WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="whatsapp-icon">
          <path fill="currentColor" d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.983 0-7.51 6.11-13.62 13.62-13.62s13.62 6.11 13.62 13.62c0 7.51-6.11 13.62-13.62 13.62zM21.305 19.26c-0.346-0.174-2.049-1.007-2.366-1.123-0.316-0.117-0.547-0.174-0.776 0.174s-0.892 1.123-1.094 1.347c-0.201 0.223-0.402 0.251-0.748 0.076-0.346-0.174-1.461-0.539-2.785-1.722-1.031-0.922-1.727-2.061-1.929-2.407-0.201-0.346-0.022-0.533 0.152-0.707 0.156-0.155 0.346-0.402 0.518-0.603 0.174-0.201 0.231-0.346 0.346-0.571 0.117-0.223 0.058-0.427-0.028-0.603s-0.776-1.87-1.063-2.565c-0.28-0.672-0.56-0.58-0.776-0.591-0.2-0.008-0.428-0.010-0.656-0.010s-0.603 0.085-0.92 0.427c-0.316 0.346-1.206 1.179-1.206 2.873s1.235 3.333 1.406 3.561c0.174 0.223 2.425 3.732 5.872 5.234 0.821 0.354 1.462 0.566 1.962 0.724 0.825 0.262 1.577 0.225 2.168 0.137 0.664-0.099 2.049-0.835 2.335-1.642 0.288-0.807 0.288-1.501 0.201-1.642-0.085-0.146-0.316-0.231-0.662-0.405z"/>
        </svg>
      </a>
    </div>
  );
}

export default App;






















